module.exports = __webpack_public_path__ + "static/media/gun-1.207e2315.glb";